export enum ProviderTypeEnum {
    Oracle,
    PostgreSQL
}
